// extracted by mini-css-extract-plugin
export default {"container":"lQ-z","modal":"mQ-z","dimensions":"nQ-z","brandName":"oQ-z","productName":"pQ-z","labelValue":"qQ-z","recipientEmail":"rQ-z","recommendedFit":"sQ-z","hiddenField":"tQ-z"};